<div class="tab-content">
  <div class="header">
    <ng-content></ng-content>
  </div>
  <div class="body">
    <form [formGroup]="technicalForm">
      <div class="sub-title subtitle-wrapper" [class.required]="isClassRequired()">
        <mat-icon style="color: red" *ngIf="getErrors(outsideInfoEnum.MAIN_DISTRIBUTION_SUBTITLE)">warning
        </mat-icon>
        <span i18n="@@survey.outside.technical.maindistribution">
          Main distribution
        </span>
      </div>
      <div class="section">
        <div class="questions">
          <div class="form-line">
            <mat-icon style="color: red; margin-right: 0.5rem" *ngIf="
                getErrors(
                  outsideInfoEnum.MAIN_DISTRIBUTION_SUBTITLE,
                  outsideInfoEnum.TYPE_FIELD
                )
              ">warning
            </mat-icon>
            <app-technical-info-question [question]="'Type'" formControlName="mainDistribution"
              [options]="mainDistributionTypeOptions" [class.disabled]="!isAuthCanWrite"
              [isRequired]="isClassRequired()" [displayError]="
                getErrors(
                  outsideInfoEnum.MAIN_DISTRIBUTION_SUBTITLE,
                  outsideInfoEnum.TYPE_FIELD
                )
              ">
            </app-technical-info-question>
          </div>
          <div class="form-line" *ngIf="
              technicalForm.contains('mainDistributionHeight') &&
              technicalForm.get('mainDistribution')?.value ==
                mainDistributionEnum.Facade
            ">
            <div class="question subtitle-wrapper" [class.required]="isClassRequired()">
              <mat-icon style="color: red" *ngIf="
                  getErrors(
                    outsideInfoEnum.MAIN_DISTRIBUTION_SUBTITLE,
                    outsideInfoEnum.FACADE_HEIGHT_FIELD
                  )
                ">warning
              </mat-icon>
              <span i18n="
                  @@survey.inside.outside.technicalinfo.question.facade.height">
                Facade height (m)
              </span>
            </div>
            <div class="input-wrapper height-input" [ngClass]="{
                'invalid-answer-input': getErrors(
                  outsideInfoEnum.MAIN_DISTRIBUTION_SUBTITLE,
                  outsideInfoEnum.FACADE_HEIGHT_FIELD
                )
              }">
              <input type="number" (keypress)="_numService.preventNonNumericalInput($event)"
                formControlName="mainDistributionHeight" class="form-control" [class.disabled]="!isAuthCanWrite" />
            </div>
          </div>
          <div class="form-line" *ngIf="
              technicalForm.contains('mainDistributionUndergroundReason') &&
              technicalForm.get('mainDistribution').value ==
                mainDistributionEnum.Underground
            ">
            <div class="question subtitle-wrapper" [class.required]="isClassRequired()">
              <mat-icon style="color: red" *ngIf="
                  getErrors(
                    outsideInfoEnum.MAIN_DISTRIBUTION_SUBTITLE,
                    outsideInfoEnum.UNDERGROUND_REASON_FIELD
                  )
                ">warning
              </mat-icon>
              <span i18n="@@survey.outside.technical.underground.reason">
                Underground reason
              </span>
            </div>
            <div class="select-wrapper" [ngClass]="{
                'invalid-answer-input': getErrors(
                  outsideInfoEnum.MAIN_DISTRIBUTION_SUBTITLE,
                  outsideInfoEnum.UNDERGROUND_REASON_FIELD
                )
              }">
              <p-dropdown [options]="mainDistributionUndergroundReasonOptions"
                formControlName="mainDistributionUndergroundReason" optionLabel="label" optionValue="value"
                placeholder="_"></p-dropdown>
            </div>
          </div>
          <div class="form-line">
            <div class="question subtitle-wrapper" [class.required]="isClassRequired()">
              <mat-icon style="color: red" *ngIf="
                  getErrors(
                    outsideInfoEnum.MAIN_DISTRIBUTION_SUBTITLE,
                    outsideInfoEnum.FRONT_YARD_FIELD
                  )
                ">warning
              </mat-icon>
              <span i18n="@@survey.outside.technical.frontyard">
                Front yard
              </span>
            </div>
            <div class="answer d-flex" [ngClass]="{
                'invalid-answer': questions.frontYard.error === true
              }">
              <button type="button" class="btn btn-outline-primary btn-yes-no btn-chip"
                [ngClass]="{ selected: questions.frontYard.value === true }" (click)="onAnswer('frontYard', true)"
                i18n="@@general.yes" [class.disabled]="!isAuthCanWrite">
                Yes
              </button>
              <button type="button" class="btn btn-outline-primary btn-yes-no btn-chip" [ngClass]="{
                  selected: questions.frontYard.value === false
                }" (click)="onAnswer('frontYard', false)" i18n="@@general.no" [class.disabled]="!isAuthCanWrite">
                No
              </button>
            </div>
          </div>
          <div class="form-line" *ngIf="questions.frontYard.value === true">
            <div class="question subtitle-wrapper" [class.required]="isClassRequired()">
              <mat-icon style="color: red" *ngIf="
                  getErrors(
                    outsideInfoEnum.MAIN_DISTRIBUTION_SUBTITLE,
                    outsideInfoEnum.FRONT_YARD_LENGTH_FIELD
                  )
                ">warning
              </mat-icon>
              <span i18n="@@survey.outside.technical.frontyard.length">
                Length front yard (m)
              </span>
            </div>
            <div class="input-wrapper height-input" [ngClass]="{
                'invalid-answer-input': getErrors(
                  outsideInfoEnum.MAIN_DISTRIBUTION_SUBTITLE,
                  outsideInfoEnum.FRONT_YARD_LENGTH_FIELD
                )
              }">
              <input type="number" (keypress)="_numService.preventNonNumericalInput($event)"
                formControlName="mainDistributionFrontYardLength" class="form-control" />
            </div>
          </div>
          <div class="form-line" *ngIf="questions.frontYard.value === true">
            <div class="question subtitle-wrapper" [class.required]="isClassRequired()">
              <mat-icon style="color: red" *ngIf="
                  getErrors(
                    outsideInfoEnum.MAIN_DISTRIBUTION_SUBTITLE,
                    outsideInfoEnum.PAVEMENT_TYPE_FIELD
                  )
                ">warning
              </mat-icon>
              <span i18n="@@survey.outside.technical.pavement"> Pavement </span>
            </div>
            <div class="select-wrapper" [ngClass]="{
                'invalid-answer-input': getErrors(
                  outsideInfoEnum.MAIN_DISTRIBUTION_SUBTITLE,
                  outsideInfoEnum.PAVEMENT_TYPE_FIELD
                )
              }">
              <p-dropdown [options]="mainDistributionFrontYardPavementOptions"
                formControlName="mainDistributionFrontYardPavement" optionLabel="label" optionValue="value"
                placeholder="_"></p-dropdown>
            </div>
          </div>
        </div>
      </div>

      <ng-container *ngIf="questions.frontYard.value === true">
        <div class="sub-title subtitle-wrapper" [class.required]="isClassRequired()">
          <mat-icon style="color: red" *ngIf="getErrors(outsideInfoEnum.FRONT_YARD_PICTURES_SUBTITLE)">warning
          </mat-icon>
          <span i18n="@@survey.outside.technical.frontyard.pictures">
            Front yard pictures
          </span>
        </div>
        <div class="section photo-section">
          <app-photo-and-remark [surveyId]="survey.id" [limit]="75" [surveyType]="surveyType.Outside"
            [surveyPhotoType]="surveyPhotoType.FrontYard" [addressId]="getMainAddressId()"
            [isAuthCanWrite]="isAuthCanWrite" [(photos)]="frontYardPhotos" [camera]="camera" [cameraLayer]="cameraLayer"
            [isInsidePhoto]="false" componentDescriptionTitle="Front Yard">
          </app-photo-and-remark>
        </div>
      </ng-container>

      <div class="sub-title subtitle-wrapper" [class.required]="isClassRequired()">
        <mat-icon style="color: red" *ngIf="getErrors(outsideInfoEnum.FACADE_SUBTITLE)">warning
        </mat-icon>
        <span i18n="@@general.facade"> Facade </span>
      </div>
      <div class="section">
        <div class="questions">
          <div class="form-line">
            <div class="question subtitle-wrapper" [class.required]="isClassRequired()">
              <mat-icon style="color: red" *ngIf="
                  getErrors(
                    outsideInfoEnum.FACADE_SUBTITLE,
                    outsideInfoEnum.CHARACTER_FACADE_FIELD
                  )
                ">warning
              </mat-icon>
              <span i18n="@@general.facade.character"> Patrimony </span>
            </div>
            <div class="answer d-flex" [ngClass]="{
                'invalid-answer': questions.patrimony.error === true
              }">
              <button type="button" class="btn btn-outline-primary btn-yes-no btn-chip"
                [ngClass]="{ selected: questions.patrimony.value === true }" (click)="onAnswer('patrimony', true)"
                i18n="@@general.yes" [class.disabled]="!isAuthCanWrite">
                Yes
              </button>
              <button type="button" class="btn btn-outline-primary btn-yes-no btn-chip"
                [ngClass]="{ selected: questions.patrimony.value === false }" (click)="onAnswer('patrimony', false)"
                i18n="@@general.no" [class.disabled]="!isAuthCanWrite">
                No
              </button>
            </div>
          </div>

          <div class="form-line">
            <div class="question subtitle-wrapper" [class.required]="isClassRequired()">
              <mat-icon style="color: red" *ngIf="
                  getErrors(
                    outsideInfoEnum.FACADE_SUBTITLE,
                    outsideInfoEnum.ELECTRICAL_CABLE_FIELD
                  )
                ">warning
              </mat-icon>
              <span i18n="@@survey.outside.technical.facade.cabling.presence">
                Presence of electrical cabling
              </span>
            </div>
            <div class="answer d-flex" [ngClass]="{
                'invalid-answer': questions.electricityCables.error === true
              }">
              <button type="button" class="btn btn-outline-primary btn-yes-no btn-chip" [ngClass]="{
                  selected: questions.electricityCables.value === true
                }" (click)="onAnswer('electricityCables', true)" i18n="@@general.yes"
                [class.disabled]="!isAuthCanWrite">
                Yes
              </button>
              <button type="button" class="btn btn-outline-primary btn-yes-no btn-chip" [ngClass]="{
                  selected: questions.electricityCables.value === false
                }" (click)="onAnswer('electricityCables', false)" i18n="@@general.no"
                [class.disabled]="!isAuthCanWrite">
                No
              </button>
            </div>
          </div>

          <div class="form-line">
            <div class="question subtitle-wrapper" [class.required]="isClassRequired()">
              <mat-icon style="color: red" *ngIf="
                  getErrors(
                    outsideInfoEnum.FACADE_SUBTITLE,
                    outsideInfoEnum.COAX_CABLE_FIELD
                  )
                ">warning
              </mat-icon>
              <span i18n="@@survey.outside.technical.facade.coax.presence">
                Presence of coax cable
              </span>
            </div>
            <div class="answer d-flex" [ngClass]="{
                'invalid-answer': questions.coaxCables.error === true
              }">
              <button type="button" class="btn btn-outline-primary btn-yes-no btn-chip"
                [ngClass]="{ selected: questions.coaxCables.value === true }" (click)="onAnswer('coaxCables', true)"
                i18n="@@general.yes" [class.disabled]="!isAuthCanWrite">
                Yes
              </button>
              <button type="button" class="btn btn-outline-primary btn-yes-no btn-chip"
                [ngClass]="{ selected: questions.coaxCables.value === false }" (click)="onAnswer('coaxCables', false)"
                i18n="@@general.no" [class.disabled]="!isAuthCanWrite">
                No
              </button>
            </div>
          </div>

          <div class="form-line">
            <div class="question subtitle-wrapper" [class.required]="isClassRequired()">
              <mat-icon style="color: red" *ngIf="
                  getErrors(
                    outsideInfoEnum.FACADE_SUBTITLE,
                    outsideInfoEnum.MULTITAB_FIELD
                  )
                ">warning
              </mat-icon>
              <span i18n="@@survey.outside.technical.facade.multitabs.presence">
                Presence of multitabs
              </span>
            </div>
            <div class="answer d-flex" [ngClass]="{
                'invalid-answer': questions.multiTap.error === true
              }">
              <button type="button" class="btn btn-outline-primary btn-yes-no btn-chip"
                [ngClass]="{ selected: questions.multiTap.value === true }" (click)="onAnswer('multiTap', true)"
                i18n="@@general.yes" [class.disabled]="!isAuthCanWrite">
                Yes
              </button>
              <button type="button" class="btn btn-outline-primary btn-yes-no btn-chip"
                [ngClass]="{ selected: questions.multiTap.value === false }" (click)="onAnswer('multiTap', false)"
                i18n="@@general.no" [class.disabled]="!isAuthCanWrite">
                No
              </button>
            </div>
          </div>

          <div class="form-line">
            <div class="question subtitle-wrapper" [class.required]="isClassRequired()">
              <mat-icon style="color: red" *ngIf="
                  getErrors(
                    outsideInfoEnum.FACADE_SUBTITLE,
                    outsideInfoEnum.PUBLIC_LIGHTING
                  )
                ">warning
              </mat-icon>
              <span i18n="@@survey.outside.technical.facade.publiclighting.presence">
                Presence of public lighting
              </span>
            </div>
            <div class="answer d-flex" [ngClass]="{
                'invalid-answer': questions.publicLightning.error === true
              }">
              <button type="button" class="btn btn-outline-primary btn-yes-no btn-chip" [ngClass]="{
                  selected: questions.publicLightning.value === true
                }" (click)="onAnswer('publicLightning', true)" i18n="@@general.yes" [class.disabled]="!isAuthCanWrite">
                Yes
              </button>
              <button type="button" class="btn btn-outline-primary btn-yes-no btn-chip" [ngClass]="{
                  selected: questions.publicLightning.value === false
                }" (click)="onAnswer('publicLightning', false)" i18n="@@general.no" [class.disabled]="!isAuthCanWrite">
                No
              </button>
            </div>
          </div>

          <div class="form-line">
            <div class="question subtitle-wrapper" [class.required]="isClassRequired()">
              <mat-icon style="color: red" *ngIf="
                  getErrors(
                    outsideInfoEnum.FACADE_SUBTITLE,
                    outsideInfoEnum.FACADE_DOUBTS_FIELD
                  )
                ">warning
              </mat-icon>
              <span i18n="@@survey.outside.technical.facade.doubts">
                Facade Doubts
              </span>
            </div>
            <div class="answer d-flex" [ngClass]="{
                'invalid-answer': questions.solutionDoubt.error === true
              }">
              <button type="button" class="btn btn-outline-primary btn-yes-no btn-chip" [ngClass]="{
                  selected: questions.solutionDoubt.value === true
                }" (click)="onAnswer('solutionDoubt', true)" i18n="@@general.yes" [class.disabled]="!isAuthCanWrite">
                Yes
              </button>
              <button type="button" class="btn btn-outline-primary btn-yes-no btn-chip" [ngClass]="{
                  selected: questions.solutionDoubt.value === false
                }" (click)="onAnswer('solutionDoubt', false)" i18n="@@general.no" [class.disabled]="!isAuthCanWrite">
                No
              </button>
            </div>
          </div>
          <div class="form-line remarks-line" *ngIf="technicalForm.contains('solutionDoubtRemark')">
            <textarea [readonly]="!isAuthCanWrite" formControlName="solutionDoubtRemark" class="remarks"
              placeholder="Add a comment..." maxlength="300" [ngClass]="{
                'invalid-select':
                  (technicalForm.get('solutionDoubtRemark')?.touched ||
                    technicalForm.get('solutionDoubtRemark')?.dirty) &&
                  technicalForm.get('solutionDoubtRemark')?.errors
              }"></textarea>
          </div>
        </div>
        <div class="sub-title" i18n="@@general.facade.remarks">
          Facade remarks
        </div>
        <div class="remarks">
          <textarea [ngModelOptions]="{ standalone: true }" [readonly]="!isAuthCanWrite" name="remarks1" class="remarks"
            placeholder="Add a comment... " maxlength="300" [(ngModel)]="remarks.facadeRemark"></textarea>
        </div>
      </div>

      <ng-container *ngIf="questions.solutionDoubt.value === true">
        <div class="sub-title" i18n="@@survey.outside.technical.facade.doubts">
          Facade Doubts
        </div>
        <div class="section photo-section">
          <app-photo-and-remark [surveyId]="survey.id" [limit]="75" [surveyType]="surveyType.Outside"
            [surveyPhotoType]="surveyPhotoType.SolutionDoubt" [addressId]="getMainAddressId()"
            [isAuthCanWrite]="isAuthCanWrite" [(photos)]="solutionDoubtPhotos" [camera]="camera"
            [cameraLayer]="cameraLayer" [isInsidePhoto]="false" componentDescriptionTitle="Facade Doubts">
          </app-photo-and-remark>
        </div>
      </ng-container>

      <div class="sub-title subtitle-wrapper" [class.required]="isClassRequired()">
        <mat-icon style="color: red" *ngIf="getErrors(outsideInfoEnum.STREET_SUBTITLE)">warning
        </mat-icon>
        <span i18n="@@general.street"> street </span>
      </div>
      <div class="section">
        <div class="questions">
          <div class="form-line">
            <div class="question subtitle-wrapper" [class.required]="isClassRequired()">
              <mat-icon style="color: red" *ngIf="
                  getErrors(
                    outsideInfoEnum.STREET_SUBTITLE,
                    outsideInfoEnum.STREET_FURNITURE_QUESTION_FIELD
                  )
                ">warning
              </mat-icon>
              <span i18n="@@general.street.furniture"> Street Furniture </span>
            </div>
            <div class="answer d-flex" [ngClass]="{
                'invalid-answer': questions.streetFurniture.error === true
              }">
              <button type="button" class="btn btn-outline-primary btn-yes-no btn-chip" [ngClass]="{
                  selected: questions.streetFurniture.value === true
                }" (click)="onAnswer('streetFurniture', true)" i18n="@@general.yes" [class.disabled]="!isAuthCanWrite">
                Yes
              </button>
              <button type="button" class="btn btn-outline-primary btn-yes-no btn-chip" [ngClass]="{
                  selected: questions.streetFurniture.value === false
                }" (click)="onAnswer('streetFurniture', false)" i18n="@@general.no" [class.disabled]="!isAuthCanWrite">
                No
              </button>
            </div>
          </div>
          <div class="form-line multi-select-line" *ngIf="questions.streetFurniture.value === true">
            <div class="question subtitle-wrapper" [class.required]="isClassRequired()">
              <mat-icon style="color: red" *ngIf="
                  getErrors(
                    outsideInfoEnum.STREET_SUBTITLE,
                    outsideInfoEnum.STREET_FURNITURE_FIELD
                  )
                ">warning
              </mat-icon>
              <span i18n="
                  @@survey.inside.outside.technicalinfo.question.streetfurniture">
                Street Furniture type
              </span>
            </div>
            <div class="multi-select-wrapper">
              <div class="select-options">
                <p-checkbox [formControl]="technicalForm.controls['streetFurnitureTypes']"
                  *ngFor="let option of streetFurnitureTypeOptions" [label]="option.label" [value]="option.value"
                  [ngClass]="{
                    'invalid-answer-checkbox': getErrors(
                      outsideInfoEnum.STREET_SUBTITLE,
                      outsideInfoEnum.STREET_FURNITURE_FIELD
                    )
                  }">
                </p-checkbox>
              </div>
            </div>
          </div>
          <div class="form-line">
            <div class="question subtitle-wrapper" [class.required]="isClassRequired()">
              <mat-icon style="color: red" *ngIf="
                  getErrors(
                    outsideInfoEnum.STREET_SUBTITLE,
                    outsideInfoEnum.FACADE_OBSTACLES_QUESTION_FIELD
                  )
                ">warning
              </mat-icon>
              <span i18n="@@survey.outside.technical.facade.obstacles">
                Facade obstacles
              </span>
            </div>
            <div class="answer d-flex" [ngClass]="{
                'invalid-answer': questions.otherObstruction.error === true
              }">
              <button type="button" class="btn btn-outline-primary btn-yes-no btn-chip" [ngClass]="{
                  selected: questions.otherObstruction.value === true
                }" (click)="onAnswer('otherObstruction', true)" i18n="@@general.yes"
                [class.disabled]="!isAuthCanWrite">
                Yes
              </button>
              <button type="button" class="btn btn-outline-primary btn-yes-no btn-chip" [ngClass]="{
                  selected: questions.otherObstruction.value === false
                }" (click)="onAnswer('otherObstruction', false)" i18n="@@general.no"
                [class.disabled]="!isAuthCanWrite">
                No
              </button>
            </div>
          </div>
          <div class="form-line multi-select-line" *ngIf="questions.otherObstruction.value === true">
            <div class="question subtitle-wrapper" [class.required]="isClassRequired()">
              <mat-icon style="color: red" *ngIf="
                  getErrors(
                    outsideInfoEnum.STREET_SUBTITLE,
                    outsideInfoEnum.FACADE_OBSTACLES_FIELD
                  )
                ">warning
              </mat-icon>
              <span i18n="@@survey.outside.technical.facade.obstacles.type">
                Type of facade obstacles
              </span>
            </div>
            <div class="multi-select-wrapper">
              <div class="select-options">
                <p-checkbox [formControl]="
                    technicalForm.controls['otherObstructionTypes']
                  " *ngFor="let option of otherObstructionTypeOptions" [label]="option.label" [value]="option.value"
                  [ngClass]="{
                    'invalid-answer-checkbox': getErrors(
                      outsideInfoEnum.STREET_SUBTITLE,
                      outsideInfoEnum.FACADE_OBSTACLES_FIELD
                    )
                  }">
                </p-checkbox>
              </div>
            </div>
          </div>
          <div class="form-line">
            <div class="question subtitle-wrapper" [class.required]="isClassRequired()">
              <mat-icon style="color: red" *ngIf="
                  getErrors(
                    outsideInfoEnum.STREET_SUBTITLE,
                    outsideInfoEnum.STREET_PAVEMENT_FIELD
                  )
                ">warning
              </mat-icon>
              <span i18n="@@survey.outside.technical.pavement.footpath">
                Type of pavement footpath
              </span>
            </div>
            <div class="select-wrapper" [ngClass]="{
                'invalid-answer-input': getErrors(
                  outsideInfoEnum.STREET_SUBTITLE,
                  outsideInfoEnum.STREET_PAVEMENT_FIELD
                )
              }">
              <p-dropdown [options]="pavingFootpathTypeOptions" formControlName="streetPavingType" optionLabel="label"
                optionValue="value" placeholder="_" [class.disabled]="!isAuthCanWrite"></p-dropdown>
            </div>
          </div>
        </div>
        <div class="sub-title" i18n="@@general.street.remarks">
          Street remarks
        </div>
        <div class="remarks">
          <textarea [ngModelOptions]="{ standalone: true }" [readonly]="!isAuthCanWrite" name="remarks1" class="remarks"
            placeholder="Add a comment..." maxlength="300" [(ngModel)]="remarks.streetRemark"></textarea>
        </div>
      </div>
      <div class="sub-title" i18n="@@general.general">General</div>
      <div class="section remarks-section">
        <div class="remarks">
          <textarea [ngModelOptions]="{ standalone: true }" [readonly]="!isAuthCanWrite" name="remarks1"
            class="general-remarks" placeholder="Add a comment..." maxlength="300"
            [(ngModel)]="remarks.generalBuildingRemark"></textarea>
        </div>
      </div>
    </form>
  </div>
</div>